import { createBrowserRouter, Navigate } from 'react-router';
import { AppShell } from '../app/layouts/AppShell';
import { AppFrame } from '../app/shell';
import { RequireAuth } from '../shared/RequireAuth';
import { SplashPage } from '../shared/pages/SplashPage';
import { SnsLoginPage } from '../shared/pages/SnsLoginPage';
import { HomePage } from '../shared/pages/HomePage';
import { AgentsPage } from '../shared/pages/AgentsPage';
import { AgentsAllTestPage } from '../shared/pages/AgentsAllTestPage';
import { ProfilePage } from '../shared/pages/ProfilePage';
import { MasterWithdrawPage } from '../shared/pages/MasterWithdrawPage';
import { StaffWithdrawPage } from '../shared/pages/StaffWithdrawPage';
import { EmployeesPage } from '../shared/pages/EmployeesPage';
import { NotificationSettingsPage } from '../shared/pages/NotificationSettingsPage';
import { ConsentPage } from '../shared/pages/ConsentPage';
import { LogoutPage } from '../shared/pages/LogoutPage';
import { SitesListPage } from '../shared/pages/SitesListPage';
import { PartnersListPage } from '../shared/pages/PartnersListPage';
import { PartnerFormPage } from '../shared/pages/PartnerFormPage';
import { VendorsListPage } from '../shared/pages/VendorsListPage';
import { VendorFormPage } from '../shared/pages/VendorFormPage';
import { NotificationsPage } from '../shared/pages/NotificationsPage';
import { NoticesPage } from '../shared/pages/NoticesPage';
import { InquiriesPage } from '../shared/pages/InquiriesPage';
import { InquiryPage } from '../shared/pages/InquiryPage';
import { InquiryDetailPage } from '../shared/pages/InquiryDetailPage';
import { FaqPage } from '../shared/pages/FaqPage';
import { StudioChatbotPage } from '../shared/pages/StudioChatbotPage';
import { NoCompanyPage } from '../shared/pages/NoCompanyPage';
import { ComingSoonPage } from '../shared/pages/ComingSoonPage';
import { TodoPage } from '../shared/pages/TodoPage';
import { TermsPage } from '../shared/pages/TermsPage';
import { PrivacyPage } from '../shared/pages/PrivacyPage';
import { AuthCallbackPage } from '../shared/pages/AuthCallbackPage';
import { MobileAuthBouncePage } from '../shared/pages/MobileAuthBouncePage';
import { ReferralLandingPage } from '../shared/pages/ReferralLandingPage';
import { PaymentMethodLandingPage } from '../shared/pages/PaymentMethodLandingPage';
import { AppLandingPage } from '../shared/pages/AppLandingPage';
import { ShareErrorPage } from '../shared/pages/ShareErrorPage';
import { ShareAuthPage } from '../shared/pages/ShareAuthPage';
import { SnsRoleSelectPage } from '../shared/pages/SnsRoleSelectPage';
import { SignupEntryPage } from '../shared/pages/SignupEntryPage';
import { MasterSnsSignupPage } from '../shared/pages/MasterSnsSignupPage';
import { StaffSnsSignupPage } from '../shared/pages/StaffSnsSignupPage';
import { BizCheckPage } from '../shared/pages/BizCheckPage';
import { WelcomePage } from '../shared/pages/WelcomePage';
import { MasterWelcomePage } from '../shared/pages/MasterWelcomePage';
import { SignupRoleSelectPage } from '../shared/pages/SignupRoleSelectPage';
import { MasterSignupPage } from '../shared/pages/MasterSignupPage';
import { StaffSignupPage } from '../shared/pages/StaffSignupPage';
import { FindIdPage } from '../shared/pages/FindIdPage';
import { FindPwPage } from '../shared/pages/FindPwPage';
import { FindPwChangePage } from '../shared/pages/FindPwChangePage';
// 테스트 관련 코드, 추후 삭제 예정
import { TestPage } from '../shared/pages/TestPage';
import { TestTermsPage } from '../shared/pages/TestTermsPage';
import { TestGuidePage } from '../shared/pages/TestGuidePage';
import { TestSupportChatPage } from '../shared/pages/TestSupportChatPage';
import { UiStandardPage } from '../shared/pages/UiStandardPage';
import { AgentComponentsPage } from '../shared/pages/agent-components/AgentComponentsPage';
import { DevMenuPage } from '../shared/pages/DevMenuPage';
import { CustomerHomePage } from '../shared/pages/CustomerHomePage';
import { CustomerHomePreviewPage } from '../shared/pages/CustomerHomePreviewPage';
import { ScrollTopButton } from '@indipia/ui-core';
import { ALL_ROUTES } from '../registry/agents';
import { ALL_SHARE_ROUTES } from '../registry/agents';

// 셸이 직접 소유하는 외부공유 착지 경로 — 해당 에이전트(work-log)가 등록한 같은 경로의 뷰어를 대신한다.
// 사장님이 WorkLog에서 고객에게 공유한 알림톡(shareType CUSTOMER_REPORT)만 고객대시보드로 연다(2026-10-02 결정).
// 사진·일정 공유는 기존 뷰어 그대로. 경로 중복을 순서에 기대지 않도록 에이전트 쪽 등록분은 여기서 제외한다.
const SHELL_OWNED_SHARE_PATHS = ['share/CUSTOMER_REPORT'];
const AGENT_SHARE_ROUTES = ALL_SHARE_ROUTES.filter((r) => !SHELL_OWNED_SHARE_PATHS.includes(r.path ?? ''));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true,      element: <SplashPage /> },
      { path: 'login',    element: <SnsLoginPage /> },       // A-2. 스튜디오 입장하기 (ID+SNS 통합)
      { path: 'find-id',        element: <FindIdPage /> },          // A-2-2. 아이디 찾기
      { path: 'find-pw',        element: <FindPwPage /> },          // A-2-3. 비밀번호 찾기
      { path: 'find-pw/change', element: <FindPwChangePage /> },    // A-2-4. 비밀번호 변경
      { path: 'signup',             element: <SignupEntryPage /> },          // A-1. 회원가입 진입 (SNS 3버튼 + 아이디로 가입)
      { path: 'signup/id',          element: <SignupRoleSelectPage /> },     // A-3-1/A-4-1. 가입 유형 선택
      { path: 'signup/master',      element: <MasterSignupPage /> },        // A-3. 일반 회원가입 (마스터)
      { path: 'signup/staff',       element: <StaffSignupPage /> },         // A-4. 일반 회원가입 (직원)
      { path: 'signup/sns',         element: <SnsRoleSelectPage /> },
      { path: 'signup/sns/master',  element: <MasterSnsSignupPage /> },
      { path: 'signup/sns/staff',   element: <StaffSnsSignupPage /> },
      { path: 'auth/callback/:provider', element: <AuthCallbackPage /> },
      { path: 'auth/mobile-callback/:provider', element: <MobileAuthBouncePage /> },
      { path: 'terms',    element: <TermsPage /> },
      { path: 'privacy',  element: <PrivacyPage /> },
      // 앱 설치 딥링크 착지 — 랜딩 "앱 설치" 버튼이 https://{host}/u/app 으로 보낸다.
      // 앱 설치+App Links 검증된 단말은 OS 가 가로채 앱이 열리고, 미설치면 이 페이지가 뜬다(공개·인증불요).
      // '/u/:token'(photo 핸드오프)보다 정적 경로라 React Router 가 이 라우트를 우선 매칭한다.
      { path: 'u/app', element: <AppLandingPage /> },
      // C-8(추천인 초대) 공유 링크 착지 — {origin}/u/r/{code}. 공개(비로그인 방문자가 대부분).
      // 경로가 `/u/`로 시작해야 모바일 앱의 검증된(autoVerify) Android App Link
      // intent-filter(pathPrefix="/u/")가 AndroidManifest.xml 수정 없이 그대로 앱으로 받을 수
      // 있다(2026-09-21 변경 — 이전엔 `/r/{code}`였음). 'r'이 고정 리터럴 세그먼트라 위 'u/app'과
      // 겹치지 않는다.
      { path: 'u/r/:code', element: <ReferralLandingPage /> },
      // 결제수단변경 알림톡 버튼 착지 — {origin}/u/pm. 공개(비로그인이어도 열림, 로그인 확인은
      // 이동 대상 페이지의 기존 가드가 처리). 'pm'이 고정 리터럴 세그먼트라 위 라우트들과 안 겹침.
      { path: 'u/pm', element: <PaymentMethodLandingPage /> },
      { path: 'share-error', element: <ShareErrorPage /> },   // 외부공유 접속 오류 (F-04 §8.2, 공개·인증불요)
      { path: 'share-auth',  element: <ShareAuthPage /> },    // 외부공유 추가 인증 입력 (F-04 §7, 공개·인증불요)
      { path: 'share/CUSTOMER_REPORT', element: <CustomerHomePage /> }, // 고객대시보드(공용, 설계서 §7.6) — 무인증 공유쿠키
      ...AGENT_SHARE_ROUTES,   // 외부공유 수신자 뷰어 (F-04 §7, 공개·FE 가드 없음 / 권한판정은 BE 콘텐츠 API)
      // guides 허브(devtools/guides-plugin.ts)에서 여는 개발용 화면 — 로그인 없이 열리고 프로덕션 빌드에는 등록하지 않는다
      ...(import.meta.env.MODE !== 'production'
        ? [
            // 스크롤 맨 위로(§15.55)는 이 라우트에만 붙인다 — 같은 페이지가 Shell 안 '/ui-standard' 에도
            // 걸려 있고 그쪽은 AppFrame 의 main 이 이미 하나 갖는다(한 화면에 둘 이상 두지 않는다).
            { path: 'guides/ui-standard', element: <><UiStandardPage /><ScrollTopButton /></> },
            { path: 'guides/agent-components', element: <AgentComponentsPage /> },
          ]
        : []),
      {
        element: <RequireAuth />,
        children: [
          // B-1 사장님 웰컴 — AppFrame 밖 독립 full-page (LeftNav/TopBar 없음)
          { path: 'master-welcome', element: <MasterWelcomePage /> },
          // 고객대시보드 발송자 미리보기 — AppFrame 밖 독립 full-page(고객이 보는 모바일 화면 그대로). 로그인 토큰으로 조회, 고객 열람 부작용 없음
          { path: 'customer-home/preview', element: <CustomerHomePreviewPage /> },
          {
            element: <AppFrame />,
            children: [
              { path: 'app', element: <HomePage /> },
              // B-2 직원 웰컴 — AppFrame 내부(스튜디오 홈 레이아웃), LeftNav는 프로필/고객센터/알림만 노출
              { path: 'app/welcome',     element: <WelcomePage /> },
              { path: 'app/no-company', element: <NoCompanyPage /> },
              { path: 'app/biz-check',  element: <BizCheckPage /> },
              { path: 'test', element: <TestPage /> }, // 테스트 관련 코드, 추후 삭제 예정
              { path: 'test/terms', element: <TestTermsPage /> }, // 테스트 — 약관확인, 추후 삭제 예정
              { path: 'test/guide', element: <TestGuidePage /> }, // 테스트 — 가이드확인, 추후 삭제 예정
              { path: 'test/support-chat', element: <TestSupportChatPage /> }, // 테스트 — 상담 채팅(고객 쪽), 추후 삭제 예정
              { path: 'dev-menu', element: <DevMenuPage /> }, // 개발자 메뉴 허브 — TopBar 숨김 버튼 진입점, 추후 삭제 예정

              // D-1. 에이전트 전체보기
              { path: 'agents', element: <AgentsPage /> },
              { path: 'agents-test', element: <AgentsAllTestPage /> }, // D-1 테스트용 정적 화면 (API 미연동)

              // UI 표준 — D-07 디자인 시스템 뷰어 (LNB "UI 표준")
              { path: 'ui-standard', element: <UiStandardPage /> },
              // 에이전트 로컬 컴포넌트 갤러리 — 앱 레이아웃(LNB·TopBar) 안 버전. 프로덕션 미등록(guides 버전과 같은 기준)
              ...(import.meta.env.MODE !== 'production' ? [{ path: 'agent-components', element: <AgentComponentsPage /> }] : []),

              // 고객 현장 목록 (우측 SiteArea 패널 대체)
              { path: 'sites', element: <SitesListPage /> },

              // F-1. 시공반장님 목록 / F-2. 등록·편집
              { path: 'partners',                      element: <PartnersListPage /> },
              { path: 'partners/new',                  element: <PartnerFormPage /> },
              { path: 'partners/:partnerId/edit',      element: <PartnerFormPage /> },

              // G-1. 자재 거래처 목록 / G-2. 등록·편집
              { path: 'vendors',                    element: <VendorsListPage /> },
              { path: 'vendors/new',                element: <VendorFormPage /> },
              { path: 'vendors/:vendorId/edit',     element: <VendorFormPage /> },

              // 고객 상담관리(구 "나의 전시장") (스튜디오 개선 설계서 §2·§9).
              // /showroom 은 후속(전시장 홈) 위한 플레이스홀더로 유지.
              // 내 프로필 홍보는 2026-10-12 개선사항 C-16으로 '내 정보 수정'에 통합 — 옛 경로(북마크·알림 링크)는 이동시킨다.
              // 나의 할일 — 오늘(/todo)·7일(/todo/week). 탭 전환은 경로 이동.
              { path: 'todo', element: <TodoPage tab="today" /> },
              { path: 'todo/week', element: <TodoPage tab="week" /> },
              { path: 'showroom', element: <ComingSoonPage title="나의 전시장" /> },
              { path: 'showroom/inquiries', element: <InquiriesPage /> },
              { path: 'showroom/profile', element: <Navigate to="/settings/profile" replace /> },

              // H-1. 알림보기
              { path: 'notifications', element: <NotificationsPage /> },

              // I-1~3. 고객센터
              { path: 'cs/notices',              element: <NoticesPage /> },
              { path: 'cs/inquiry',              element: <InquiryPage /> },
              { path: 'cs/inquiry/:inquiryId',   element: <InquiryDetailPage /> },
              { path: 'cs/faq',                  element: <FaqPage /> },
              { path: 'cs/chatbot',              element: <StudioChatbotPage /> },

              // J-1~5. 사용자 설정
              { path: 'settings/profile',           element: <ProfilePage /> },
              { path: 'settings/withdraw/master',   element: <MasterWithdrawPage /> },
              { path: 'settings/withdraw/staff',    element: <StaffWithdrawPage /> },
              { path: 'settings/employees',         element: <EmployeesPage /> },
              { path: 'settings/notification',      element: <NotificationSettingsPage /> },
              { path: 'settings/consent',           element: <ConsentPage /> },
              { path: 'settings/logout',            element: <LogoutPage /> },

              ...ALL_ROUTES,
            ],
          },
        ],
      },
    ],
  },
]);
